module.exports = __webpack_public_path__ + "static/media/CormorantGaramond-BoldItalic.9f8e79d5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/CormorantGaramond-BoldItalic.ttf
// module id = 3140
// module chunks = 70